import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { GetPaidLists } from '@/connection/audiences/paid-lists';

export const fetchPaidLists = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async (channel: number) => {
      return await GetPaidLists(channel);
    },
    {
      fulfilled: (state, action) => {
        state.paidLists = action.payload;
      },
    }
  );
